module.exports = __webpack_public_path__ + "img/ic_fluent_eraser_24_regular.ff8c705f.svg";